import React from 'react';
import { Grid, Button, Typography } from '@mui/material';

interface handleClick {
  onClickCancel?: any;
  title?: string;
  textTransform?: any;
  padding?: any;
  fontSize?: any;
}
const CustomCancelButton: React.FC<handleClick> = ({
  onClickCancel,
  title,
  textTransform = 'uppercase',
  padding,
  fontSize,
}) => {
  return (
    <Grid item xs={12}>
      <Button
        style={{
          margin: '6px',
          minWidth: '118px',
          maxWidth: 'fitContent',
          height: 'auto',
          maxHeight: '52px',
          border: '1px solid #f44336',
          color: '#f44336',
          borderRadius: '4px',
          fontFamily: 'Lato',
          textTransform: textTransform,
        }}
        onClick={onClickCancel}
      >
        <Typography padding={padding} fontSize={fontSize}>
          {title}
        </Typography>
      </Button>
    </Grid>
  );
};

export default CustomCancelButton;
